import { CurrentUserResponse } from '@/app/network/models/v1/user';
import { useUser } from '@/shared/user/queries';

export function useCurrentUser(): CurrentUserResponse {
  const { data } = useUser();
  if (data === undefined) {
    throw new Error('No user in session.');
  }

  return data;
}
